export default {
      id: "tap-usage",
      viewBox: "0 0 36.28 54.55",
      url: __webpack_public_path__ + "svgs/icons.91fe9319.svg#tap",
      toString: function () {
        return this.url;
      }
    }